import React, { Component } from 'react'
import Message from '../components/Message'
import InfoMessage from '../components/InfoMessage'
import SingleImage from '../components/SingleImage'
import SingleVideo from '../components/SingleVideo'
import Carousel from '../components/Carousel'
import CarouselInfoMessage from '../components/CarouselInfoMessage'
import ListButton from '../components/ListButton'
import {
  isImage,
  isCarousel,
  isVideo,
  isTextMessage,
  isListButton,
  isInfoMessage,
} from '../../redux/utils'

const messageStyle = {
  display: 'inline-block',
  maxWidth: '70%',
  boxShadow: 'rgba(220, 220, 220, 0.5) 0px 0px 26px 0px',
  marginBottom: '10px',
  padding: '',
  overflow: 'hidden',
  fontSize: '16px',
}

const userMessageStyle = {
  ...messageStyle,
  borderRadius: '5px',
  padding: '6px 17px',
  backgroundColor: 'rgba(53,52,57,1.00)',
  color: 'white',
}

const botMessageStyle = {
  ...messageStyle,
  padding: '6px 17px',
  borderRadius: '6px',
  backgroundColor: '#EDEDED',
  color: '#666666',
}

const imageVideoBotMessageStyle = {
  ...botMessageStyle,
  padding: '0',
  boxShadow: 'none',
  border: '1px solid black'
};

class ChatHistory extends Component {
  render() {

    const {
      messages,
      isBotTyping,
    } = this.props;

    /*eslint-disable array-callback-return*/
    const computedMessages = messages.map((message, index) => {
      /*console.log("message", message);*/
      if (message.userMessage) {
        if (message.userMessage === "/start" || message.userMessage === "/startagain") {
          return null
        } else {
          /*console.log('-------------------------------------------------------------------');
          console.log('case userMessage');
          console.log('message', message);
          message.userMessage
          ? console.log('message.userMessage', message.userMessage)
          : console.error('message.userMessage undefined', message)
          console.log('-------------------------------------------------------------------');*/
          return (
            <div
            key={`${message.id}|${index}` || `${message.userMessage}|${index}`}
            className="containerChat user"
            >
              <span
              style={userMessageStyle}
              >
                <Message message={message.userMessage} />
              </span>
            </div>
            )
        }
      } else if (isTextMessage(message)) {
        /*console.log('-------------------------------------------------------------------');
        console.log('case isTextMessage');
        console.log('message', message);
        message.text
        ? console.log('message.text', message.text)
        : console.error('message.text undefined', message)
        console.log('-------------------------------------------------------------------');*/
        return (
          <div
            className="containerChat text-reply"
            key={message.id}
          >
            <span style={botMessageStyle}>
              <Message message={message.text} />
            </span>
          </div>
        )
      } else if (isInfoMessage(message)) {
        if (message.attachments.length > 1) {
          return (
            <div
              className="containerChat info-message-container"
              key={message.id}
            >
              <span className="info-message-content" style={{ ...botMessageStyle, backgroundColor: 'rgb(248, 248, 249)', boxShadow: 'none' }}>
                <CarouselInfoMessage className="info-messages" message={message.attachments} />
              </span>
            </div>
          )
        } else {
          return (
            <div
              className="containerChat info-message-container-short"
              key={message.id}
            >
              <span  className="info-message-span-content">
                <InfoMessage message={message.attachments[0].content} />
              </span>
            </div>
          )
        }
      } else if (isCarousel(message)) {
        /*console.log('-------------------------------------------------------------------');
                  console.log('case isCarousel');
                  console.log('message', message);
                  console.log('-------------------------------------------------------------------');*/
        return (
          <div
            className="containerChat carrousel-container"
            key={message.id}
          >
            <span className="carrousel-content" style={{ ...imageVideoBotMessageStyle, width: '95%', background: 'none', boxShadow: 'none', overflow: 'visible', border: 'none' }} key={message.id}>
              <Carousel
                className=" carrousel"
                message={message}
                last={messages.length === (messages.indexOf(message) + 1)}
                width={530}
                secondRow={this.props.secondRow}
              />
            </span>
          </div>
        )
      } else if (message.attachments) {
        const attachment = message.attachments[0]
        if (isListButton(message)) {
          /*console.log('-------------------------------------------------------------------');
          console.log('case isListButton');
          console.log('message', message);
          console.log('message.attachments[0].content.text', message.attachments[0].content.text);
          message.attachments[0].content.text
          ? console.log('message.attachments[0].content.text', message.attachments[0].content.text)
          : console.error('message.attachments[0].content.text undefined', message)
          console.log('-------------------------------------------------------------------');*/
          return (
            <div
              className="containerChat basic-container"
              key={message.id}
            >
              <span style={botMessageStyle}>
                <Message message={message.attachments[0].content.text} />
              </span>
              <ListButton message={message} />
            </div>
          )
        } else if (isImage(message)) {
          return (
            <div
              className="containerChat image"
              key={message.id}
            >
              <span style={imageVideoBotMessageStyle}>
                <SingleImage src={attachment.contentUrl} />
              </span>
            </div>
          )
        } else if (isVideo(message)) {
          return (
            <div
              className="containerChat video"
              key={message.id}
            >
              <span style={{ ...imageVideoBotMessageStyle, minWidth: '400px' }}>
                <SingleVideo src={attachment.content.media[0].url} />
              </span>
            </div>
          )
        }
      } else {
        /*console.log('-------------------------------------------------------------------');
        console.error('case else - error handling');
        console.error('message', message);
        console.log('-------------------------------------------------------------------');*/
        return (
          <span
            style={botMessageStyle}
            key={message.id}>
            <div
              className="containerChat other-basic-container"
            >
              <span>
                <Message message="Error In Message Computing Please Contact Admin" />
              </span>
            </div>
          </span>
        )
      }
    });
    /*eslint-disable array-callback-return*/
    if (isBotTyping) {
      /*console.log('-------------------------------------------------------------------');
      console.log('case bot is typing');
      console.log('-------------------------------------------------------------------');*/
      computedMessages.push(
        <div
          key="botIsTyping"
          className="containerChat bot-typing"
        >
          <span style={{ ...botMessageStyle, fontSize: '35px' }} className="botIsTypingDots">
            <Message message="..." className="botIsTypingDots"/>
          </span>
        </div>,
      )
    }
    return (
      <div
      >
        {computedMessages}
      </div>
    )
  }
}

export default ChatHistory



// WEBPACK FOOTER //
// ./src/views/layouts/ChatHistory.js